import React from 'react';
import { Link } from 'react-router-dom';
import { FiChevronRight } from 'react-icons/fi';
import BreadcrumbSchema from './BreadcrumbSchema';
import '../styles/Breadcrumbs.css';

const Breadcrumbs = ({ items }) => {
  return (
    <>
      {/* Visual breadcrumbs for users */}
      <nav className="breadcrumbs" aria-label="Breadcrumb">
        <ol>
          {items.map((item, index) => {
            const isLast = index === items.length - 1;
            return (
              <li key={index} className={isLast ? 'active' : ''}>
                {!isLast ? (
                  <>
                    <Link to={item.path}>{item.name}</Link>
                    <FiChevronRight className="breadcrumb-separator" aria-hidden="true" />
                  </>
                ) : (
                  <span>{item.name}</span>
                )}
              </li>
            );
          })}
        </ol>
      </nav>
      
      {/* Schema.org breadcrumbs for search engines */}
      <BreadcrumbSchema items={items.map(item => ({ name: item.name, url: `https://quick-inbox.com${item.path}` }))} />
    </>
  );
};

export default Breadcrumbs; 